import { module } from 'modujs';
import { html } from '../utils/environment';

const COOKIE_NAME = 'iti-alert-banner';
const COOKIE_MAX_AGE_DAYS = 30;
const HEIGHT_PROPERTY = '--alert-banner-height';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'close': 'close'
            }
        }
    }

    init() {
        if (hasCookie(COOKIE_NAME)) {
            this.setHeight(0);
            return;
        }

        // Already open on the previous page (AJAX transition): skip the animation.
        if (parseFloat(html.style.getPropertyValue(HEIGHT_PROPERTY)) > 0) {
            this.el.style.transition = 'none';
        }

        this.isOpen = true;
        this.open();

        window.addEventListener('resizeEnd', this.onResize = () => this.open());
    }

    open() {
        if (!this.isOpen) return;

        this.setHeight(this.$('inner')[0].scrollHeight);
        setTimeout(() => this.el.style.transition = '', 50);
    }

    close() {
        this.isOpen = false;
        setCookie(COOKIE_NAME, 'closed', COOKIE_MAX_AGE_DAYS);
        this.setHeight(0);
    }

    setHeight(height) {
        const current = parseFloat(html.style.getPropertyValue(HEIGHT_PROPERTY)) || 0;

        this.el.style.height = height + 'px';
        html.style.setProperty(HEIGHT_PROPERTY, height + 'px');

        // Let Locomotive Scroll and sticky elements recalculate once the transition ends.
        if (current !== height) {
            setTimeout(() => window.dispatchEvent(new Event('resize')), 650);
        }
    }

    destroy() {
        window.removeEventListener('resizeEnd', this.onResize);
    }
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
}

function hasCookie(name) {
    return document.cookie.split('; ').some((row) => row.indexOf(name + '=') === 0);
}
